import React, { useRef, useState, useEffect } from 'react';
import anime from 'animejs/lib/anime.es.js';
import { gtmTracking } from '../../js/helpers';
import './FooterInfo.scss'

const additionalInfoData = [
  {
    title: 'What units of measurement are used?',
    body: 'The harmful and potentially harmful constituents are measured in three units of weight: <br/> Milligrams (mg). 1 milligram = 1,000th of a gram <br/> Micrograms (μg). 1 microgram = 1,000,000th of a gram Nanograms (ng). 1 nanogram = 1,000,000,000th of a gram',
  },
  {
    title: 'What this tool does not cover',
    body: 'This tool does not cover the results from the toxicological, clinical, and long-term assessments conducted for our leading heated tobacco product, which can be found elsewhere on our <a target="_blank" href="https://www.pmi.com/our-science/our-findings-to-date">website</a>.',
  },
  {
    title: 'More on nicotine',
    body: 'Nicotine is measured in the Health Canada Intense Testing Regime, and the data are used to assess product performance. But it is not a target for reduction compared to cigarettes, and therefore it is not covered in this tool.',
  },
  {
    title: 'Glycerol, water, and aerosol collected mass',
    body: 'This tool does not provide information on glycerol, water, aerosol collected mass, as these are not harmful or potentially harmful constituents.',
  },
  {
    title: 'Accessibility guide',
    body: 'Key "a" goes to "All constituents" button <br/> Key "s" goes to current active constituents in the sidebar',
  },
];

const FooterInfo = () => {
  const tooltipInfoRef = useRef();
  const tooltipRef = useRef();

  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const [isTooltipBody, setIsTooltipBody] = useState(false);
  const [currentTooltipData, setCurrentTooltipData] = useState();

  const toggleTooltipHandler = () => {
    setIsTooltipOpen(() => !isTooltipOpen);
    setIsTooltipBody(false);
  };

  const changeHandler = (e) => {
    if (!tooltipInfoRef.current.contains(e.target)) {
      setIsTooltipOpen(false);
      setIsTooltipBody(false);
    }
  };

  const showTooltipTextHandler = (index) => {
    setCurrentTooltipData(additionalInfoData[index]);
    setIsTooltipBody(true);
  };

  useEffect(() => {
    if (isTooltipBody) {
      anime({
        targets: tooltipRef.current,
        opacity: [0, 1],
        left: [-20, 0],
        easing: 'easeOutExpo',
      });
    } else {
      anime({
        targets: tooltipRef.current,
        opacity: [0, 1],
        left: [20, 0],
        easing: 'easeOutExpo',
      });
    }
  }, [isTooltipBody]);

  useEffect(() => {
    if (!isTooltipOpen) {
      return;
    }
    anime({
      targets: tooltipRef.current,
      opacity: [0, 1],
      easing: 'easeOutExpo',
    });

    document.addEventListener('click', changeHandler);
    return () => document.removeEventListener('click', changeHandler);
  }, [isTooltipOpen]);

  useEffect(() => {
    const timeLine = anime.timeline({
      delay: 1500,
      easing: 'easeOutExpo',
      direction: 'alternate',
      loop: true,
    });

    timeLine.add({
      targets: '.svg-iconFill',
      opacity: [1, 0],
      easing: 'easeOutQuad',
      duration: 1000,
    });

    timeLine.add(
      {
        targets: '.svg-iconFull',
        opacity: [0, 1],
        easing: 'easeOutQuad',
      },
      '-=2500'
    );
  }, []);

  const classActive = isTooltipOpen ? 'tos-footer__button--active' : '';

  return (
    <div className='tos-footer__info' ref={tooltipInfoRef}>
      <button
        className={`tos-footer__button ${classActive}`}
        onClick={() => {
          toggleTooltipHandler();
          gtmTracking('navigation', 'additional information');
        }}
      >
        <div className='tos-footer__button-main-icon'>
          <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className='svg-iconFill'
          >
            <path
              d='M23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5C18.3513 0.5 23.5 5.64873 23.5 12Z'
              stroke='white'
            />
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M10.3322 9.19538C9.98655 9.80623 9.22193 10.0149 8.6243 9.66161C8.02673 9.30824 7.82252 8.52659 8.1682 7.91573C8.8147 6.77329 10.0262 6 11.4158 6C13.4868 6 15.1658 7.71625 15.1658 9.83333C15.1657 11.236 14.3241 12.3812 13.2908 13.0278C12.4608 13.5472 12.9783 14.9444 11.4124 14.9444C10.7222 14.9444 10.1624 14.3724 10.1624 13.6667C10.1624 13.6218 10.1647 13.5775 10.1692 13.5338C10.2038 12.8581 10.4986 12.3081 10.8196 11.9083C11.1586 11.4861 11.6042 11.1414 11.9449 10.9343C13.8408 9.78222 11.5284 7.42523 10.3322 9.19538ZM11.4124 16.2222C10.7222 16.2222 10.1624 16.7943 10.1624 17.5C10.1624 18.2057 10.7222 18.7778 11.4124 18.7778C12.1028 18.7778 12.6624 18.2057 12.6624 17.5C12.6624 16.7943 12.1028 16.2222 11.4124 16.2222Z'
              fill='white'
            />
          </svg>
          <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className='svg-iconFull'
          >
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM8.6243 9.60595C9.22193 9.95924 9.98655 9.75057 10.3322 9.13971C11.5284 7.36957 13.8408 9.72656 11.9449 10.8786C11.6042 11.0857 11.1586 11.4305 10.8196 11.8527C10.4986 12.2525 10.2038 12.8024 10.1692 13.4781C10.1647 13.5218 10.1624 13.5662 10.1624 13.611C10.1624 14.3167 10.7222 14.8888 11.4124 14.8888C12.3653 14.8888 12.5467 14.3713 12.7297 13.8492C12.8475 13.5133 12.9659 13.1754 13.2908 12.9721C14.3241 12.3256 15.1657 11.1803 15.1658 9.77767C15.1658 7.66058 13.4868 5.94434 11.4158 5.94434C10.0262 5.94434 8.8147 6.71762 8.1682 7.86007C7.82252 8.47093 8.02673 9.25258 8.6243 9.60595ZM10.1624 17.4443C10.1624 16.7386 10.7222 16.1666 11.4124 16.1666C12.1028 16.1666 12.6624 16.7386 12.6624 17.4443C12.6624 18.1501 12.1028 18.7221 11.4124 18.7221C10.7222 18.7221 10.1624 18.1501 10.1624 17.4443Z'
              fill='white'
            />
          </svg>
        </div>

        <span className='tos-footer__button-icon-title'>
          Additional information
        </span>
      </button>

      {isTooltipOpen && (
        <div
          className='tos-footer__tooltip tos-footer__tooltip--info'
          ref={tooltipRef}
        >
          <button
            className='tos-footer__tooltip-close'
            onClick={() => {
              setIsTooltipOpen(false);
              setIsTooltipBody(false);
            }}
          >
            &times;
          </button>
          <ul
            className={`tos-footer__info-tooltip-list ${
              isTooltipBody && 'tos-footer__info-tooltip-list--open'
            }`}
          >
            {additionalInfoData.map((info, index) => (
              <li key={index}>
                <button
                  onClick={() => {
                    showTooltipTextHandler(index);
                    gtmTracking('additional information', info?.title);
                  }}
                >
                  {info?.title}
                </button>
              </li>
            ))}
          </ul>

          <div
            className={`tos-footer__info-content ${
              !isTooltipBody && 'tos-footer__info-content--inactive'
            }`}
          >
            <div>
              <button
                className='tos-footer__info-content-btn'
                onClick={() => {
                  setIsTooltipBody(false);
                }}
              >
                Back
              </button>
              <button
                className='tos-footer__tooltip-close'
                onClick={() => {
                  setIsTooltipOpen(false);
                  setIsTooltipBody(false);
                }}
              >
                &times;
              </button>
            </div>
            <div className='tos-footer__info-title-wrapper'>
              <div className='tos-footer__button-icon'>
                <svg
                  width='8'
                  height='14'
                  viewBox='0 0 8 14'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M2.33218 4.13971C1.98655 4.75057 1.22193 4.95924 0.624303 4.60595C0.0267285 4.25258 -0.177483 3.47092 0.168204 2.86007C0.814704 1.71762 2.02618 0.944336 3.4158 0.944336C5.4868 0.944336 7.1658 2.66058 7.1658 4.77767C7.16568 6.18029 6.32405 7.32556 5.2908 7.97211C4.4608 8.49153 4.9783 9.88878 3.41243 9.88878C2.72218 9.88878 2.16243 9.31672 2.16243 8.611C2.16243 8.56615 2.16468 8.52181 2.16918 8.47811C2.2038 7.80242 2.49855 7.25247 2.81955 6.85265C3.15855 6.43048 3.60418 6.08573 3.94493 5.8786C5.8408 4.72656 3.52843 2.36957 2.33218 4.13971ZM3.41243 11.1666C2.72218 11.1666 2.16243 11.7386 2.16243 12.4443C2.16243 13.1501 2.72218 13.7221 3.41243 13.7221C4.1028 13.7221 4.66243 13.1501 4.66243 12.4443C4.66243 11.7386 4.1028 11.1666 3.41243 11.1666Z'
                    fill='white'
                  ></path>
                </svg>
              </div>
              <span className='tos-footer__info-title'>
                {currentTooltipData?.title}
              </span>
            </div>
            <div
              className='tos-footer__info-paragraph'
              dangerouslySetInnerHTML={{
                __html: `<p>${currentTooltipData?.body}</p>`,
              }}
            ></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FooterInfo;
